import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
} from "react";

import { useHistory, useParams } from "react-router-dom";
import { parseISO, format, isSameDay } from "date-fns";
import clsx from "clsx";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { green, grey } from "@material-ui/core/colors";
import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import MarkdownWrapper from "../MarkdownWrapper";
import { Tooltip } from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import toastError from "../../errors/toastError";
import { v4 as uuidv4 } from "uuid";

// Removido import de ícone - usando emoji para melhor compatibilidade
import ContactTag from "../ContactTag";
import ConnectionIcon from "../ConnectionIcon";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import ShowTicketOpen from "../ShowTicketOpenModal";
import FinalizacaoVendaModal from "../FinalizacaoVendaModal";
import { isNil } from "lodash";
import toastUtils from "../../utils/toastUtils";
import { Done, HighlightOff, Replay, SwapHoriz, Image, Mic, Videocam, InsertDriveFile, LocationOn, ContactPhone } from "@material-ui/icons";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import NotificationsOffIcon from "@material-ui/icons/NotificationsOff";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import PushPinIcon from "@mui/icons-material/PushPin";
import VisibilityIcon from "@material-ui/icons/Visibility"; // Ícone de spy
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { useCompanySettingsContext } from "../../context/CompanySettings/CompanySettingsContext";
import {
  Avatar,
  Badge,
  ListItemAvatar,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  Menu,
  MenuItem,
  ListItemIcon,
  Checkbox,
  IconButton,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  ticket: {
    position: "relative",
    transition: "background-color 0.2s",
  },
  pinnedTicket: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.04)' : '#f7f9fa',
    borderLeft: `3px solid ${theme.palette.primary.main}`,
  },
  selectedTicket: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(33, 150, 243, 0.15)' : '#e3f2fd !important',
  },
  contextMenu: {
    "& .MuiPaper-root": {
      borderRadius: 8,
      boxShadow: theme.shadows[4],
      minWidth: 190,
    },
  },

  pendingTicket: {
    cursor: "unset",
  },
  queueTag: {
    background: theme.palette.type === 'dark' ? '#252525' : "#FCFCFC",
    color: theme.palette.text.primary,
    marginRight: 1,
    padding: 1,
    fontWeight: "bold",
    borderRadius: 3,
    fontSize: "0.5em",
    whiteSpace: "nowrap",
  },
  noTicketsDiv: {
    display: "flex",
    height: "100px",
    margin: 40,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  newMessagesCount: {
    justifySelf: "flex-end",
    textAlign: "right",
    position: "relative",
    top: 0,
    color: "green",
    fontWeight: "bold",
    marginRight: "10px",
    borderRadius: 0,
  },
  noTicketsText: {
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "14px",
    lineHeight: "1.4",
  },
  connectionTag: {
    background: "green",
    color: "#FFF",
    marginRight: 1,
    padding: 1,
    fontWeight: "bold",
    borderRadius: 3,
    fontSize: "0.6em",
  },
  noTicketsTitle: {
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "600",
    margin: "0px",
  },

  contactNameWrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "5px",
    fontWeight: "bold",
    color: theme.mode === "light" ? "black" : "white",
  },

  lastMessageTime: {
    justifySelf: "flex-end",
    textAlign: "right",
    position: "relative",
    top: -30,
    marginRight: "1px",
    color: theme.mode === "light" ? "black" : grey[400],
  },

  lastMessageTimeUnread: {
    justifySelf: "flex-end",
    textAlign: "right",
    position: "relative",
    top: -30,
    color: "green",
    fontWeight: "bold",
    marginRight: "1px",
  },

  closedBadge: {
    alignSelf: "center",
    justifySelf: "flex-end",
    marginRight: 32,
    marginLeft: "auto",
  },

  contactLastMessage: {
    paddingRight: "0%",
    marginLeft: "5px",
    color: theme.mode === "light" ? "black" : grey[400],
  },

  contactLastMessageUnread: {
    paddingRight: 20,
    fontWeight: "bold",
    color: theme.mode === "light" ? "black" : grey[400],
    width: "50%",
  },

  badgeStyle: {
    color: "white",
    backgroundColor: green[500],
  },

  acceptButton: {
    position: "absolute",
    right: "1px",
  },

  ticketQueueColor: {
    flex: "none",
    height: "100%",
    position: "absolute",
    top: "0%",
    left: "0%",
  },

  ticketInfo: {
    position: "relative",
    top: -13,
  },
  secondaryContentSecond: {
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignContent: "flex-start",
  },
  ticketInfo1: {
    position: "relative",
    top: 13,
    right: 0,
  },
  Radiusdot: {
    "& .MuiBadge-badge": {
      borderRadius: 2,
      position: "inherit",
      height: 16,
      margin: 2,
      padding: 3,
    },
    "& .MuiBadge-anchorOriginTopRightRectangle": {
      transform: "scale(1) translate(0%, -40%)",
    },
  },
  connectionIcon: {
    marginRight: theme.spacing(1),
  },

  // Estilos para o modal da imagem
  imageModal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  imageModalContent: {
    outline: "none",
    maxWidth: "90vw",
    maxHeight: "90vh",
  },
  expandedImage: {
    width: "100%",
    height: "auto",
    maxWidth: "500px",
    borderRadius: theme.spacing(1),
  },
  clickableAvatar: {
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  }
}));

const TicketListItemCustom = ({
  setTabOpen,
  ticket,
  isSelected,
  onToggleSelect,
  selectionMode,
  onEnableSelection,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [contextMenu, setContextMenu] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const handleContextMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setContextMenu(
      contextMenu === null
        ? { mouseX: e.clientX + 2, mouseY: e.clientY - 6 }
        : null
    );
  };

  const handleCloseContextMenu = () => {
    setContextMenu(null);
    setMenuAnchorEl(null);
  };

  const handleOpenMenuClick = (e) => {
    e.stopPropagation();
    setMenuAnchorEl(e.currentTarget);
  };

  const handleTogglePin = async (e) => {
    if (e) e.stopPropagation();
    handleCloseContextMenu();
    try {
      const isPinned = !Boolean(ticket.isPinned);
      await api.put(`/tickets/${ticket.id}/pin`, { isPinned });
      toastUtils.success(
        isPinned ? "Fixado" : "Desafixado",
        isPinned ? "Conversa fixada no topo!" : "Conversa desafixada."
      );
    } catch (err) {
      toastError(err);
    }
  };

  const handleToggleMute = async (e) => {
    if (e) e.stopPropagation();
    handleCloseContextMenu();
    try {
      const isMuted = !Boolean(ticket.isMuted);
      await api.put(`/tickets/${ticket.id}/mute`, { isMuted });
      toastUtils.success(
        isMuted ? "Silenciado" : "Reativado",
        isMuted ? "Notificações silenciadas." : "Notificações reativadas."
      );
    } catch (err) {
      toastError(err);
    }
  };

  const [
    acceptTicketWithouSelectQueueOpen,
    setAcceptTicketWithouSelectQueueOpen,
  ] = useState(false);
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");

  // Estados para o modal de finalização de venda
  const [openFinalizacaoVenda, setOpenFinalizacaoVenda] = useState(false);
  const [, setFinalizacaoTipo] = useState(null);
  const [ticketDataToFinalize, setTicketDataToFinalize] = useState(null);
  const [showFinalizacaoOptions, setShowFinalizacaoOptions] = useState(false);

  const [imageModalOpen, setImageModalOpen] = useState(false); // Estado para o modal da imagem
  const [requireQueueSelect, setRequireQueueSelect] = useState(false);

  const { ticketId } = useParams();
  const isMounted = useRef(true);
  const { setCurrentTicket } = useContext(TicketsContext);
  const { user } = useContext(AuthContext);

  const { get: getSetting } = useCompanySettings();
  const { getSetting: getCompanySetting } = useCompanySettingsContext();

  const renderSlaBadge = () => {
    const timeMonitoringEnabled = getCompanySetting ? getCompanySetting("timeMonitoringEnabled", false) : false;
    const isMonitoringActive = Boolean(
      timeMonitoringEnabled === true ||
      timeMonitoringEnabled === "true" ||
      timeMonitoringEnabled === "enabled"
    );

    if (!isMonitoringActive) return null;
    if (ticket.status === "closed" || !ticket.responseTimeStart) return null;

    const queueSla = ticket.queue?.slaMinutes ? Number(ticket.queue.slaMinutes) : null;
    const defaultLimit = Number(getCompanySetting("responseTimeLimit", 30)) || 30;
    const limit = queueSla && queueSla > 0 ? queueSla : defaultLimit;

    const defaultWarning = Number(getCompanySetting("timeMonitoringWarningMinutes", 5)) || 5;
    const warningMin = ticket.queue?.slaWarningMinutes ? Number(ticket.queue.slaWarningMinutes) : defaultWarning;

    const startTime = new Date(ticket.responseTimeStart).getTime();
    const elapsedMinutes = Math.max(0, (Date.now() - startTime) / (1000 * 60));
    const remainingMinutes = Math.round(limit - elapsedMinutes);

    if (remainingMinutes <= 0 || ticket.responseTimeoutTriggered) {
      return (
        <Tooltip title={`SLA estourado! Limite de ${limit}min excedido`}>
          <span
            style={{
              backgroundColor: "#e53935",
              color: "#fff",
              fontSize: "0.68rem",
              fontWeight: "bold",
              padding: "2px 6px",
              borderRadius: 10,
              marginLeft: 4,
              display: "inline-flex",
              alignItems: "center",
              gap: 2
            }}
          >
            🔥 +{Math.abs(remainingMinutes)}m
          </span>
        </Tooltip>
      );
    }

    if (remainingMinutes <= warningMin) {
      return (
        <Tooltip title={`Atenção! Restam ${remainingMinutes}min para resposta (Limite: ${limit}min)`}>
          <span
            style={{
              backgroundColor: "#fb8c00",
              color: "#fff",
              fontSize: "0.68rem",
              fontWeight: "bold",
              padding: "2px 6px",
              borderRadius: 10,
              marginLeft: 4,
              display: "inline-flex",
              alignItems: "center",
              gap: 2
            }}
          >
            ⚠️ {remainingMinutes}m
          </span>
        </Tooltip>
      );
    }

    return (
      <Tooltip title={`Tempo de resposta: restam ${remainingMinutes}min (Limite: ${limit}min)`}>
        <span
          style={{
            backgroundColor: "#43a047",
            color: "#fff",
            fontSize: "0.68rem",
            fontWeight: "bold",
            padding: "2px 6px",
            borderRadius: 10,
            marginLeft: 4,
            display: "inline-flex",
            alignItems: "center",
            gap: 2
          }}
        >
          ⏳ {remainingMinutes}m
        </span>
      </Tooltip>
    );
  };

  useEffect(() => {
    const fetchAlwaysSelectQueueOnAcceptSetting = async () => {
      try {
        const setting = await getSetting({
          column: "alwaysSelectQueueOnAccept"
        });
        if (isMounted.current) {
          setRequireQueueSelect(setting.alwaysSelectQueueOnAccept === "enabled");
        }
      } catch (err) {
        console.error(err);
        if (isMounted.current) {
          setRequireQueueSelect(false);
        }
      }
    };

    fetchAlwaysSelectQueueOnAcceptSetting();

    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Função para abrir modal da imagem
  const handleImageClick = (e) => {
    e.stopPropagation(); // Prevenir que o clique no avatar selecione o ticket
    if (ticket?.contact?.urlPicture) {
      setImageModalOpen(true);
    }
  };

  // Função para fechar modal da imagem
  const handleImageModalClose = () => {
    setImageModalOpen(false);
  };

  const handleOpenAcceptTicketWithouSelectQueue = useCallback(() => {
    setAcceptTicketWithouSelectQueueOpen(true);
  }, []);

  const handleCloseTicket = async (id) => {
    // Verificar se a finalização com valor de venda está ativa
    if (
      user.finalizacaoComValorVendaAtiva === true ||
      user.finalizacaoComValorVendaAtiva === "true"
    ) {
      // Se estiver ativa, abrir o modal de finalização de venda
      setFinalizacaoTipo("comDespedida");
      setOpenFinalizacaoVenda(true);
      handleSelectTicket(ticket);
      history.push(`/tickets/${ticket.uuid}`);
    } else {
      // Comportamento original
      const setting = await getSetting({
        column: "requiredTag",
      });

      if (setting.requiredTag === "enabled") {
        //verificar se tem uma tag
        try {
          const contactTags = await api.get(
            `/contactTags/${ticket.contact.id}`
          );
          if (!contactTags.data.tags) {
            toastUtils.warning("Tag Obrigatória", i18n.t("messagesList.header.buttons.requiredTag"));
          } else {
            await api.put(`/tickets/${id}`, {
              status: "closed",
              userId: user?.id || null,
            });

            if (isMounted.current) {
              setLoading(false);
            }

            history.push(`/tickets/`);
          }
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      } else {
        setLoading(true);
        try {
          await api.put(`/tickets/${id}`, {
            status: "closed",
            userId: user?.id || null,
          });
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
        if (isMounted.current) {
          setLoading(false);
        }

        history.push(`/tickets/`);
      }
    }
  };

  const handleCloseIgnoreTicket = async (id) => {
    setLoading(true);
    try {
      await api.put(`/tickets/${id}`, {
        status: "closed",
        userId: user?.id || null,
        sendFarewellMessage: false,
        amountUsedBotQueues: 0,
      });
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
    if (isMounted.current) {
      setLoading(false);
    }

    history.push(`/tickets/`);
  };

  const truncate = (str, len) => {
    if (!isNil(str)) {
      if (str.length > len) {
        return str.substring(0, len) + "...";
      }
      return str;
    }
  };

  const handleCloseTransferTicketModal = useCallback(() => {
    if (isMounted.current) {
      setTransferTicketModalOpen(false);
    }
  }, []);

  const handleOpenTransferModal = () => {
    setLoading(true);
    setTransferTicketModalOpen(true);
    if (isMounted.current) {
      setLoading(false);
    }
    handleSelectTicket(ticket);
    history.push(`/tickets/${ticket.uuid}`);
  };

  const handleAcepptTicket = async (id) => {
    setLoading(true);
    try {
      // Verificar limite de tickets antes de aceitar
      let ticketLimitCheck = { canAcceptTicket: true }; // Default fallback
      try {
        const { data } = await api.get('/users/ticket-limit-check');
        ticketLimitCheck = data;
      } catch (limitError) {
        console.warn('Erro ao verificar limite de tickets, permitindo continuar:', limitError);
        // Em caso de erro na verificação de limite, permitir continuar
      }

      if (!ticketLimitCheck.canAcceptTicket) {
        setLoading(false);
        toastUtils.warning("Limite de Tickets", ticketLimitCheck.message || 'Você atingiu o limite máximo de tickets ativos');
        return;
      }

      const otherTicket = await api.put(`/tickets/${id}`, {
        status:
          ticket.isGroup && ticket.channel === "whatsapp" ? "group" : "open",
        userId: user?.id,
      });

      if (otherTicket.data.id !== ticket.id) {
        if (otherTicket.data.userId !== user?.id) {
          setOpenAlert(true);
          setUserTicketOpen(otherTicket.data.user.name);
          setQueueTicketOpen(otherTicket.data.queue.name);
        } else {
          setLoading(false);
          setTabOpen(ticket.isGroup ? "group" : "open");
          handleSelectTicket(otherTicket.data);
          history.push(`/tickets/${otherTicket.uuid}`);
        }
      } else {


        // Mensagem de aceite agora é enviada automaticamente pelo backend
        // if (
        //   setting.sendGreetingAccepted === "enabled" &&
        //   (!ticket.isGroup || ticket.whatsapp?.groupAsTicket === "enabled")
        // ) {
        //   handleSendMessage(ticket.id);
        // }
        if (isMounted.current) {
          setLoading(false);
        }

        setTabOpen(ticket.isGroup ? "group" : "open");
        handleSelectTicket(ticket);
        history.push(`/tickets/${ticket.uuid}`);
      }
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };


  const handleCloseAlert = useCallback(() => {
    setOpenAlert(false);
    setLoading(false);
  }, []);

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid } = ticket;
    setCurrentTicket({ id, uuid, code });
  };

  const handleUpdateTicketStatusWithData = async (
    ticketData,
    sendFarewellMessage,
    finalizacaoMessage
  ) => {
    try {
      await api.put(`/tickets/${ticket.id}`, {
        ...ticketData,
        sendFarewellMessage,
        finalizacaoMessage,
      });
      toastUtils.success("Ticket Finalizado", "Ticket finalizado com sucesso!");
      history.push(`/tickets/`);
    } catch (err) {
      toastError(err);
    }
  };

  // Função para espionar ticket chatbot
  const handleSpyTicket = () => {
    handleSelectTicket(ticket);
    history.push(`/tickets/${ticket.uuid}`);
  };

  // Lógica de permissão para mensagens pending - MOVIDA PARA DEPOIS DE TODAS AS FUNÇÕES
  const shouldBlurMessages = ticket.status === "pending" && user?.allowSeeMessagesInPendingTickets === "disabled";

  // Função para renderizar a mensagem com base na permissão - MOVIDA PARA DEPOIS DE TODAS AS FUNÇÕES
  const renderLastMessage = () => {
    if (shouldBlurMessages) {
      return (
        <MarkdownWrapper>
          {i18n.t("tickets.messageHidden") || "Mensagem oculta"}
        </MarkdownWrapper>
      );
    }

    if (!ticket.lastMessage) {
      return <br />;
    }

    const rawLastMsg = ticket.lastMessage;
    const cleanMsg = rawLastMsg
      .replace(/\[TEMPLATE\]\s*/gi, '')
      .replace(/\[INTERATIVA\]\s*/gi, '')
      .replace(/\[BUTTON\]\s*/gi, '')
      .replace(/\[LIST\]\s*/gi, '')
      .trim();
    const iconStyle = { fontSize: 16, marginRight: 4, verticalAlign: "middle", color: "#667781" };

    // Detectar localização (base64)
    if (cleanMsg.includes("data:image/png;base64")) {
      return (
        <span style={{ display: "flex", alignItems: "center" }}>
          <LocationOn style={iconStyle} />
          <span>Localização</span>
        </span>
      );
    }

    // Detectar vCard (contato)
    if (cleanMsg.includes("BEGIN:VCARD")) {
      return (
        <span style={{ display: "flex", alignItems: "center" }}>
          <ContactPhone style={iconStyle} />
          <span>Contato</span>
        </span>
      );
    }

    // Detectar imagem - padrões comuns
    if (cleanMsg === "🖼️ Imagem" || 
        cleanMsg.match(/\.(jpg|jpeg|png|gif|webp)$/i) ||
        cleanMsg.startsWith("📷") ||
        cleanMsg === "image") {
      return (
        <span style={{ display: "flex", alignItems: "center" }}>
          <Image style={iconStyle} />
          <span>Imagem</span>
        </span>
      );
    }

    // Detectar áudio
    if (cleanMsg === "🎵 Arquivo de áudio" || 
        cleanMsg === "🎵 Mensagem de voz" ||
        cleanMsg.match(/\.(mp3|ogg|wav|m4a|aac|opus)$/i) ||
        cleanMsg.startsWith("🎵") ||
        cleanMsg === "audio" ||
        cleanMsg.includes("Áudio gravado")) {
      return (
        <span style={{ display: "flex", alignItems: "center" }}>
          <Mic style={iconStyle} />
          <span>Áudio</span>
        </span>
      );
    }

    // Detectar vídeo
    if (cleanMsg === "🎥 Arquivo de vídeo" || 
        cleanMsg.match(/\.(mp4|webm|avi|mov|mkv)$/i) ||
        cleanMsg.startsWith("🎥") ||
        cleanMsg === "video") {
      return (
        <span style={{ display: "flex", alignItems: "center" }}>
          <Videocam style={iconStyle} />
          <span>Vídeo</span>
        </span>
      );
    }

    // Detectar documento
    if (cleanMsg === "📂 Documento" || 
        cleanMsg === "📎 Outros anexos" ||
        cleanMsg.startsWith("📂") ||
        cleanMsg.startsWith("📎") ||
        cleanMsg.match(/\.(pdf|doc|docx|xls|xlsx|ppt|pptx|txt|csv|zip|rar|pfx|p12|cer|crt|pem)$/i) ||
        cleanMsg.startsWith("📄") ||
        cleanMsg === "document" ||
        cleanMsg === "application") {
      const displayName = cleanMsg
        .replace(/^(📄|📂|📎)\s*/, "")
        .replace(/^Documento:\s*/i, "")
        .trim();
      return (
        <span style={{ display: "flex", alignItems: "center" }}>
          <InsertDriveFile style={iconStyle} />
          <span>{truncate(displayName, 35) || "Documento"}</span>
        </span>
      );
    }

    // Detectar sticker
    if (cleanMsg === "sticker" || cleanMsg.includes(".webp")) {
      return (
        <span style={{ display: "flex", alignItems: "center" }}>
          <span style={{ fontSize: 16, marginRight: 4 }}>
            <span role="img" aria-label="figurinha">🎭</span>
          </span>
          <span>Figurinha</span>
        </span>
      );
    }

    return (
      <MarkdownWrapper>
        {truncate(cleanMsg, 40)}
      </MarkdownWrapper>
    );
  };

  return (
    <React.Fragment key={ticket.id}>
      {openAlert && (
        <ShowTicketOpen
          isOpen={openAlert}
          handleClose={handleCloseAlert}
          user={userTicketOpen}
          queue={queueTicketOpen}
        />
      )}
      {acceptTicketWithouSelectQueueOpen && (
        <AcceptTicketWithouSelectQueue
          modalOpen={acceptTicketWithouSelectQueueOpen}
          onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
          ticketId={ticket.id}
          ticket={ticket}
        />
      )}
      {transferTicketModalOpen && (
        <TransferTicketModalCustom
          modalOpen={transferTicketModalOpen}
          onClose={handleCloseTransferTicketModal}
          ticketid={ticket.id}
          ticket={ticket}
        />
      )}
      <ListItem
        button
        dense
        onClick={(e) => {
          if (selectionMode) {
            e.stopPropagation();
            if (typeof onToggleSelect === "function") {
              onToggleSelect(ticket.id);
            }
            return;
          }
          const isCheckboxClicked =
            (e.target.tagName.toLowerCase() === "input" &&
              e.target.type === "checkbox") ||
            (e.target.tagName.toLowerCase() === "svg" &&
              e.target.type === undefined) ||
            (e.target.tagName.toLowerCase() === "path" &&
              e.target.type === undefined);

          if (isCheckboxClicked) return;

          handleSelectTicket(ticket);
        }}
        onContextMenu={handleContextMenu}
        selected={ticketId && ticketId === ticket.uuid}
        className={clsx(classes.ticket, {
          [classes.pendingTicket]: ticket.status === "pending",
          [classes.pinnedTicket]: Boolean(ticket.isPinned),
          [classes.selectedTicket]: Boolean(isSelected),
        })}
      >
        {selectionMode && (
          <Checkbox
            checked={Boolean(isSelected)}
            onChange={(e) => {
              e.stopPropagation();
              if (typeof onToggleSelect === "function") {
                onToggleSelect(ticket.id);
              }
            }}
            onClick={(e) => e.stopPropagation()}
            color="primary"
            style={{ padding: 4, marginRight: 2, zIndex: 2 }}
          />
        )}
        <ListItemAvatar style={{ marginLeft: selectionMode ? "0px" : "-15px" }}>
          <Avatar
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
            }}
            src={ticket?.contact?.urlPicture || ticket?.contact?.profilePicUrl || undefined}
            className={classes.clickableAvatar}
            onClick={handleImageClick}
          >
            {ticket?.contact?.name ? ticket.contact.name.charAt(0).toUpperCase() : "?"}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          disableTypography
          primary={
            <span className={classes.contactNameWrapper}>
              <Typography
                noWrap
                component="span"
                variant="body2"
                style={{ maxWidth: "calc(100% - 105px)" }}
              >
                {ticket.channel && (
                  <ConnectionIcon
                    width="20"
                    height="20"
                    className={classes.connectionIcon}
                    connectionType={ticket.channel}
                  />
                )}{" "}
                &nbsp;
                {truncate(ticket.contact?.name, 60)}
              </Typography>
            </span>
          }
          secondary={
            <span className={classes.contactNameWrapper}>
              <Typography
                className={
                  Number(ticket.unreadMessages) > 0
                    ? classes.contactLastMessageUnread
                    : classes.contactLastMessage
                }
                noWrap
                component="span"
                variant="body2"
                style={{ paddingRight: 80 }}
              >
                {renderLastMessage()}
                <span className={classes.secondaryContentSecond}>
                  {/* 🔥 ÍCONE PARA TICKETS DE GRUPO */}
                  {ticket.isGroup && ticket.channel === "whatsapp" && (
                    <span
                      style={{
                        fontSize: "14px",
                        marginRight: "4px",
                        verticalAlign: "middle"
                      }}
                    >
                      <span role="img" aria-label="grupo">👥</span>
                    </span>
                  )}
                  {ticket?.whatsapp ? (
                    <Badge
                      className={classes.connectionTag}
                      style={{
                        backgroundColor:
                          ticket.channel === "whatsapp"
                            ? ticket.whatsapp?.color || "#25D366"
                            : ticket.channel === "facebook"
                            ? "#4267B2"
                            : ticket.channel === "telegram"
                            ? "#0088cc"
                            : "#E1306C", // Instagram
                      }}
                    >
                      {ticket.whatsapp?.name.toUpperCase()}
                    </Badge>
                  ) : (
                    <br></br>
                  )}
                  {/* 🔥 NÃO EXIBIR BADGE DE QUEUE PARA TICKETS DE GRUPO */}
                  {!ticket.isGroup && (
                    <Badge
                      style={{
                        backgroundColor: ticket.queue?.color || "#7c7c7c",
                      }}
                      className={classes.connectionTag}
                    >
                      {ticket.queueId
                        ? ticket.queue?.name.toUpperCase()
                        : ticket.status === "lgpd"
                        ? "LGPD"
                        : `${i18n.t("momentsUser.noqueue")}`}
                    </Badge>
                  )}
                  {ticket?.user && (
                    <Badge
                      style={{ backgroundColor: theme.palette.type === 'dark' ? '#444' : "#000000" }}
                      className={classes.connectionTag}
                    >
                      {ticket.user?.name.toUpperCase()}
                    </Badge>
                  )}
                  {renderSlaBadge()}
                </span>
                <span className={classes.secondaryContentSecond}>
                  {ticket?.contact?.tags?.map((tag) => {
                    return (
                      <ContactTag
                        tag={tag}
                        key={`ticket-contact-tag-${ticket.id}-${tag.id}`}
                      />
                    );
                  })}
                </span>
                <span className={classes.secondaryContentSecond}>
                  {ticket.tags?.map((tag) => {
                    return (
                      <ContactTag
                        tag={tag}
                        key={`ticket-contact-tag-${ticket.id}-${tag.id}`}
                      />
                    );
                  })}
                </span>
              </Typography>
            </span>
          }
        />
        <ListItemSecondaryAction>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              position: "relative",
              top: -24,
              gap: 4,
            }}
          >
            {Boolean(ticket.isMuted) && (
              <Tooltip title="Notificações silenciadas">
                <NotificationsOffIcon
                  style={{
                    fontSize: 15,
                    color: theme.palette.type === "dark" ? "#8696a0" : "#8696a0",
                  }}
                />
              </Tooltip>
            )}

            {Boolean(ticket.isPinned) && (
              <Tooltip title="Conversa fixada">
                <PushPinIcon
                  style={{
                    fontSize: 15,
                    transform: "rotate(45deg)",
                    color: theme.palette.type === "dark" ? "#8696a0" : "#8696a0",
                  }}
                />
              </Tooltip>
            )}

            {ticket.lastMessage && (
              <Typography
                className={
                  Number(ticket.unreadMessages) > 0
                    ? classes.lastMessageTimeUnread
                    : classes.lastMessageTime
                }
                component="span"
                variant="body2"
                style={{ position: "static", top: 0, margin: 0, fontSize: "0.75rem" }}
              >
                {isSameDay(parseISO(ticket.updatedAt), new Date()) ? (
                  <>{format(parseISO(ticket.updatedAt), "HH:mm")}</>
                ) : (
                  <>{format(parseISO(ticket.updatedAt), "dd/MM/yyyy")}</>
                )}
              </Typography>
            )}

            {Number(ticket.unreadMessages) > 0 && (
              <span
                style={{
                  backgroundColor: "#25D366",
                  color: "#FFFFFF",
                  fontSize: "0.7rem",
                  fontWeight: "bold",
                  minWidth: 18,
                  height: 18,
                  borderRadius: 9,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 5px",
                  lineHeight: 1,
                  boxSizing: "border-box",
                  marginLeft: 1,
                }}
              >
                {shouldBlurMessages ? "?" : ticket.unreadMessages}
              </span>
            )}

            <IconButton
              size="small"
              style={{
                padding: 2,
                marginLeft: 1,
                color: theme.palette.type === "dark" ? "#8696a0" : "#8696a0",
              }}
              onClick={handleOpenMenuClick}
            >
              <MoreVertIcon style={{ fontSize: 16 }} />
            </IconButton>
          </div>
        </ListItemSecondaryAction>
        <ListItemSecondaryAction>
          {/* Para tickets com status chatbot, mostrar apenas o ícone de spy */}
          {ticket.status === "chatbot" && (
            <span className={classes.secondaryContentSecond}>
              <ButtonWithSpinner
                style={{
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  border: "none",
                  color: theme.mode === "light" ? "blue" : "#FFF",
                  padding: "0px",
                  borderRadius: "50%",
                  right: "1px",
                  fontSize: "0.6rem",
                  bottom: "-30px",
                  minWidth: "2em",
                  width: "auto",
                }}
                variant="contained"
                className={classes.acceptButton}
                size="small"
                loading={loading}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSpyTicket();
                }}
              >
                <Tooltip title="Espiar conversa do chatbot">
                  <VisibilityIcon />
                </Tooltip>
              </ButtonWithSpinner>
            </span>
          )}

          {/* Para todos os outros status, manter os botões originais */}
          {ticket.status !== "chatbot" && (
            <>
              <span className={classes.secondaryContentSecond}>
                {ticket.status === "pending" &&
                  (requireQueueSelect || ticket.queueId === null || ticket.queueId === undefined) && (
                    <ButtonWithSpinner
                      style={{
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        border: "none",
                        color: theme.mode === "light" ? "green" : "#FFF",
                        padding: "0px",
                        borderRadius: "50%",
                        right: "51px",
                        fontSize: "0.6rem",
                        bottom: "-30px",
                        minWidth: "2em",
                        width: "auto",
                      }}
                      variant="contained"
                      className={classes.acceptButton}
                      size="small"
                      loading={loading}
                      onClick={(e) => handleOpenAcceptTicketWithouSelectQueue()}
                    >
                      <Tooltip title={`${i18n.t("ticketsList.buttons.accept")}`}>
                        <Done />
                      </Tooltip>
                    </ButtonWithSpinner>
                  )}
              </span>
              <span className={classes.secondaryContentSecond}>
                {ticket.status === "pending" && !requireQueueSelect && ticket.queueId !== null && (
                  <ButtonWithSpinner
                    style={{
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      border: "none",
                      color: theme.mode === "light" ? "green" : "#FFF",
                      padding: "0px",
                      borderRadius: "50%",
                      right: "51px",
                      fontSize: "0.6rem",
                      bottom: "-30px",
                      minWidth: "2em",
                      width: "auto",
                    }}
                    variant="contained"
                    className={classes.acceptButton}
                    size="small"
                    loading={loading}
                    onClick={(e) => handleAcepptTicket(ticket.id)}
                  >
                    <Tooltip title={`${i18n.t("ticketsList.buttons.accept")}`}>
                      <Done />
                    </Tooltip>
                  </ButtonWithSpinner>
                )}
              </span>
              <span className={classes.secondaryContentSecond1}>
                {!ticket.isGroup &&
                  ticket.status !== "group" &&
                  (ticket.status === "pending" ||
                    ticket.status === "open") && (
                  <ButtonWithSpinner
                    style={{
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      border: "none",
                      color: theme.mode === "light" ? "purple" : "#FFF",
                      padding: "0px",
                      borderRadius: "50%",
                      right: "26px",
                      position: "absolute",
                      fontSize: "0.6rem",
                      bottom: "-30px",
                      minWidth: "2em",
                      width: "auto",
                    }}
                    variant="contained"
                    className={classes.acceptButton}
                    size="small"
                    loading={loading}
                    onClick={handleOpenTransferModal}
                  >
                    <Tooltip title={`${i18n.t("ticketsList.buttons.transfer")}`}>
                      <SwapHoriz />
                    </Tooltip>
                  </ButtonWithSpinner>
                )}
              </span>
              <span className={classes.secondaryContentSecond}>
                {((ticket.status === "open" && !ticket.isGroup) ||
                  ((ticket.isGroup || ticket.status === "group") &&
                    (user?.profile === "admin" || user?.profile === "superadmin"))) && (
                  <ButtonWithSpinner
                    style={{
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      border: "none",
                      color: theme.mode === "light" ? "red" : "#FFF",
                      padding: "0px",
                      borderRadius: "50%",
                      right: "1px",
                      fontSize: "0.6rem",
                      bottom: "-30px",
                      minWidth: "2em",
                      width: "auto",
                    }}
                    variant="contained"
                    className={classes.acceptButton}
                    size="small"
                    loading={loading}
                    onClick={(e) => handleCloseTicket(ticket.id)}
                  >
                    <Tooltip title={`${i18n.t("ticketsList.buttons.closed")}`}>
                      <HighlightOff />
                    </Tooltip>
                  </ButtonWithSpinner>
                )}
              </span>
              <span className={classes.secondaryContentSecond}>
                {(ticket.status === "pending" || ticket.status === "lgpd") &&
                  (user.userClosePendingTicket === "enabled" ||
                    user.profile === "admin") && (
                    <ButtonWithSpinner
                      style={{
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        border: "none",
                        color: theme.mode === "light" ? "red" : "#FFF",
                        padding: "0px",
                        borderRadius: "50%",
                        right: "1px",
                        fontSize: "0.6rem",
                        bottom: "-30px",
                        minWidth: "2em",
                        width: "auto",
                      }}
                      variant="contained"
                      className={classes.acceptButton}
                      size="small"
                      loading={loading}
                      onClick={(e) => handleCloseIgnoreTicket(ticket.id)}
                    >
                      <Tooltip title={`${i18n.t("ticketsList.buttons.ignore")}`}>
                        <HighlightOff />
                      </Tooltip>
                    </ButtonWithSpinner>
                  )}
              </span>
              <span className={classes.secondaryContentSecond}>
                {ticket.status === "closed" &&
                  (ticket.queueId === null || ticket.queueId === undefined) && (
                    <ButtonWithSpinner
                      style={{
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        border: "none",
                        color: theme.mode === "light" ? "orange" : "#FFF",
                        padding: "0px",
                        borderRadius: "50%",
                        right: "1px",
                        fontSize: "0.6rem",
                        bottom: "-30px",
                        minWidth: "2em",
                        width: "auto",
                      }}
                      variant="contained"
                      className={classes.acceptButton}
                      size="small"
                      loading={loading}
                      onClick={(e) => handleOpenAcceptTicketWithouSelectQueue()}
                    >
                      <Tooltip title={`${i18n.t("ticketsList.buttons.reopen")}`}>
                        <Replay />
                      </Tooltip>
                    </ButtonWithSpinner>
                  )}
              </span>
              <span className={classes.secondaryContentSecond}>
                {ticket.status === "closed" && ticket.queueId !== null && (
                  <ButtonWithSpinner
                    style={{
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      border: "none",
                      color: theme.mode === "light" ? "orange" : "#FFF",
                      padding: "0px",
                      borderRadius: "50%",
                      right: "1px",
                      fontSize: "0.6rem",
                      bottom: "-30px",
                      minWidth: "2em",
                      width: "auto",
                    }}
                    variant="contained"
                    className={classes.acceptButton}
                    size="small"
                    loading={loading}
                    onClick={(e) => handleAcepptTicket(ticket.id)}
                  >
                    <Tooltip title={`${i18n.t("ticketsList.buttons.reopen")}`}>
                      <Replay />
                    </Tooltip>
                  </ButtonWithSpinner>
                )}
              </span>
            </>
          )}
        </ListItemSecondaryAction>
      </ListItem>

      {/* Modal de Finalização de Venda */}
      {openFinalizacaoVenda && (
        <FinalizacaoVendaModal
          open={openFinalizacaoVenda}
          onClose={() => setOpenFinalizacaoVenda(false)}
          ticket={ticket}
          onFinalizar={(ticketData) => {
            setOpenFinalizacaoVenda(false);
            setTicketDataToFinalize(ticketData);
            setShowFinalizacaoOptions(true);
          }}
        />
      )}

      {/* Modal de Opções de Finalização */}
      {showFinalizacaoOptions && (
        <Dialog
          open={showFinalizacaoOptions}
          onClose={() => setShowFinalizacaoOptions(false)}
          aria-labelledby="finalizacao-options-title"
        >
          <DialogTitle id="finalizacao-options-title">
            Como deseja finalizar?
          </DialogTitle>
          <DialogActions>
            <Button
              onClick={async () => {
                setShowFinalizacaoOptions(false);
                await handleUpdateTicketStatusWithData(
                  ticketDataToFinalize,
                  false,
                  null
                );
              }}
              style={{ background: theme.palette.primary.main, color: "white" }}
            >
              {i18n.t("messagesList.header.dialogRatingWithoutFarewellMsg")}
            </Button>
            <Button
              onClick={async () => {
                setShowFinalizacaoOptions(false);
                await handleUpdateTicketStatusWithData(
                  ticketDataToFinalize,
                  true,
                  null
                );
              }}
              style={{ background: theme.palette.primary.main, color: "white" }}
            >
              {i18n.t("messagesList.header.dialogRatingCancel")}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Modal da Imagem */}
      <Dialog
        open={imageModalOpen}
        onClose={handleImageModalClose}
        className={classes.imageModal}
        maxWidth="md"
        fullWidth
      >
        <DialogContent className={classes.imageModalContent}>
          <img 
            src={ticket?.contact?.urlPicture} 
            alt={ticket?.contact?.name || "Foto do contato"}
            className={classes.expandedImage}
          />
        </DialogContent>
      </Dialog>

      {/* Menu de Contexto e Opções (Fixar / Silenciar / Selecionar) */}
      <Menu
        keepMounted
        open={Boolean(contextMenu) || Boolean(menuAnchorEl)}
        onClose={handleCloseContextMenu}
        anchorReference={contextMenu ? "anchorPosition" : "anchorEl"}
        anchorEl={menuAnchorEl}
        anchorPosition={
          contextMenu
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
        className={classes.contextMenu}
      >
        <MenuItem onClick={handleTogglePin}>
          <ListItemIcon style={{ minWidth: 32 }}>
            <PushPinIcon
              fontSize="small"
              style={ticket.isPinned ? { color: "#f44336" } : { transform: "rotate(45deg)", color: "#666" }}
            />
          </ListItemIcon>
          <ListItemText primary={ticket.isPinned ? "Desafixar conversa" : "Fixar conversa"} />
        </MenuItem>
        <MenuItem onClick={handleToggleMute}>
          <ListItemIcon style={{ minWidth: 32 }}>
            {ticket.isMuted ? (
              <NotificationsActiveIcon fontSize="small" style={{ color: "#4caf50" }} />
            ) : (
              <NotificationsOffIcon fontSize="small" style={{ color: "#f44336" }} />
            )}
          </ListItemIcon>
          <ListItemText primary={ticket.isMuted ? "Reativar notificações" : "Silenciar notificações"} />
        </MenuItem>
        {onEnableSelection && (
          <MenuItem
            onClick={() => {
              handleCloseContextMenu();
              onEnableSelection(ticket.id);
            }}
          >
            <ListItemIcon style={{ minWidth: 32 }}>
              <CheckBoxIcon fontSize="small" style={{ color: "#2196f3" }} />
            </ListItemIcon>
            <ListItemText primary="Selecionar conversa" />
          </MenuItem>
        )}
      </Menu>
    </React.Fragment>
  );
};

export default React.memo(TicketListItemCustom, (prevProps, nextProps) => {
  return (
    prevProps.ticket?.id === nextProps.ticket?.id &&
    prevProps.ticket?.unreadMessages === nextProps.ticket?.unreadMessages &&
    prevProps.ticket?.updatedAt === nextProps.ticket?.updatedAt &&
    prevProps.ticket?.status === nextProps.ticket?.status &&
    prevProps.ticket?.userId === nextProps.ticket?.userId &&
    prevProps.ticket?.queueId === nextProps.ticket?.queueId &&
    prevProps.ticket?.lastMessage === nextProps.ticket?.lastMessage &&
    prevProps.ticket?.channel === nextProps.ticket?.channel &&
    prevProps.ticket?.isPinned === nextProps.ticket?.isPinned &&
    prevProps.ticket?.isMuted === nextProps.ticket?.isMuted &&
    prevProps.isSelected === nextProps.isSelected &&
    prevProps.selectionMode === nextProps.selectionMode
  );
});